// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  googleApiKey: 'AIzaSyByOKTQNo8JtrA7wzx_T3JjwoA-T09K9lM',
  googleClientId: '1014438195138-199891earggs30teujpbm1dpva940g6b.apps.googleusercontent.com',
  analyticsPropertyId: '449080752'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
